import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Title', defaultMessage: 'Title' },
  visibleOn: { id: 'Visible on', defaultMessage: 'Visible on' },
  phone: { id: 'Phone', defaultMessage: 'Phone' },
  tablet: { id: 'Tablet', defaultMessage: 'Tablet' },
  desktop: { id: 'Desktop', defaultMessage: 'Desktop' },
});

const Schema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.visibleOn),
    fieldsets: [
      {
        id: 'default',
        title: 'Visible on',
        fields: ['phone', 'tablet', 'desktop'],
      },
    ],
    properties: {
      tablet: {
        title: intl.formatMessage(messages.tablet),
        type: 'boolean',
        default: false,
        required: true,
      },
      desktop: {
        title: intl.formatMessage(messages.desktop),
        type: 'boolean',
        default: false,
        required: true,
      },
      phone: {
        title: intl.formatMessage(messages.phone),
        type: 'boolean',
        default: false,
        required: true,
      },
    },
    required: ['tablet', 'desktop', 'phone'],
  };
};

export default Schema;
